import { Layout, Menu, Button, Avatar, ConfigProvider } from 'antd'
import { TeamOutlined, LogoutOutlined, UserOutlined, GlobalOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import arEG from 'antd/locale/ar_EG'
import enUS from 'antd/locale/en_US'
import '../i18n/i18n'
import AdminClients from './AdminClients'

const { Sider, Content, Header } = Layout

function AdminDashboard({ admin, onLogout }) {
  const { t, i18n } = useTranslation()
  const [current, setCurrent] = useState('clients')
  const [language, setLanguage] = useState(localStorage.getItem('app_language') || 'ar')

  useEffect(() => {
    i18n.changeLanguage(language)
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = language
    localStorage.setItem('app_language', language)
  }, [language, i18n])

  const toggleLanguage = () => setLanguage(prev => (prev === 'ar' ? 'en' : 'ar'))

  const items = [
    { key: 'clients', icon: <TeamOutlined />, label: t('adminDashboard.menuClients') }
  ]

  return (
    <ConfigProvider direction={language === 'ar' ? 'rtl' : 'ltr'} locale={language === 'ar' ? arEG : enUS}>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider theme="dark">
          <div style={{
            color: 'white',
            textAlign: 'center',
            padding: '16px',
            fontSize: '16px',
            fontWeight: 'bold',
            background: '#001529'
          }}>
            {t('adminDashboard.sidebarTitle')}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[current]}
            items={items}
            onClick={e => setCurrent(e.key)}
          />
        </Sider>

        <Layout>
          <Header style={{
            background: '#001529',
            padding: '0 24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>
              {t('adminDashboard.headerTitle')}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Button icon={<GlobalOutlined />} onClick={toggleLanguage}>
                {t('language.switchTo')}
              </Button>
              <Avatar icon={<UserOutlined />} />
              <span style={{ color: 'white' }}>{admin.name}</span>
              <Button icon={<LogoutOutlined />} onClick={onLogout} danger>
                {t('common.logout')}
              </Button>
            </div>
          </Header>

          <Content style={{ margin: 24 }}>
            {current === 'clients' && <AdminClients />}
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  )
}

export default AdminDashboard
